import { Injectable } from '@angular/core';
import { HttpParams, HttpEventType, HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject, ReplaySubject, forkJoin, throwError } from 'rxjs';

import { MenuUrls } from '../global.urls';
import * as Classes from '../classes/models.classes';
import { ShortsPostSave } from '../interfaces/models.interfaces';
import { map, tap } from 'rxjs/operators';

//import { Http } from '@angular/http';

@Injectable({
    providedIn: 'any'
})
export class UserMenuDataService {
    lcl_params: Classes.UserID_Params;
    private postsSubject = new BehaviorSubject<Classes.ShortsPosts[]>([]); // Observable stream for posts
    private reactionsSubject = new BehaviorSubject<any>(null);  // For reactions

  constructor(
    private http: HttpClient) {

  }

    loadUTrendingTopics(userID: number): Observable<Classes.TrendingTopic[]> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        // Create request body with userID
        const body: any = { userID };

        return this.http.post<any[]>(MenuUrls.GetTrendingTopics, body, { headers }).pipe(
            map(trending =>
                trending.map(post => {
                    // Pass the entire post object to the constructor
                    return new Classes.TrendingTopic();
                })
            )
        );
    }


    getTrendingTopics(userId: number): Observable<Classes.TrendingTopic[]> {
        return this.http.get<Classes.TrendingTopic[]>(`${MenuUrls.GetTrendingTopics}/${userId}`);
    }

    getSuggestedUsers(userId: number): Observable<Classes.UserSuggestion[]> {
        return this.http.get<Classes.UserSuggestion[]>(`${MenuUrls.GetSuggestedUsers}/${userId}`);
    }

    getSponsoredPosts(userId: number): Observable<Classes.SponsoredPost[]> {
        return this.http.get<Classes.SponsoredPost[]>(`${MenuUrls.GetSponsoredPosts}/${userId}`);
    }



}
